import { BG_SCHEMA, SUBTITLE_SCHEMA, TEXT_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const FOOTER_LOGO_ITEM = () => ({
  image: 'https://cdn.blueticket.com.br/assets/bt-logo-azul.png'
})

export const FOOTER_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'footer',
    id: id,
    idLayout: idLayout,
    pageId: pageId,
    name: '',
    subtitle: SUBTITLE_SCHEMA(),
    text: TEXT_SCHEMA(),
    bg: BG_SCHEMA(),
    contact: { email: 'contato@contato.com.br', phone: '', site: 'https://www.blueticket.com.br', title: 'Contato'},
    organization: { title: 'Realização', logos: [FOOTER_LOGO_ITEM()]},
    social: {title: 'Siga-nos', facebook: 'blueticket', instagram: 'blueticketbrasil', youtube: 'blueticket'},
    'item-color': '#202020'
  }
}

export const beforeParseFooter = target => {
  commonBeforeParseMethod(target, ['bg'])
}

export const FOOTER_SECTION = config => ({
  schema: FOOTER_SCHEMA(config),
  beforeParse: beforeParseFooter
})
